export default "__VITE_ASSET__CgxGXCMS__"